<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    <b-input-group append="T" class="length">
      <b-form-input v-model="innerValue.args.turnCount" 
        type="number" min="1" max="30" number />
    </b-input-group>
    <b-form-select v-model="innerValue.args.turnOperator" 
      :options="[
        { value:'every', text:'毎' },
        { value:'eq', text:'目' },
        { value:'eq-less', text:'以内' },
        { value:'eq-more', text:'以後' },
      ]" 
      class="buff" />
    <b-button variant="danger" size="sm"
      @click="$emit('remove')">
      <b-icon icon="x" />
    </b-button>
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
.length {
  display: inline-flex;
  width: 100px;
}
.buff {
  display: inline-block;
  width: 75px;
}
</style>